<div class="p-4">
    <!-- Title -->
    <h2 class="text-xl font-semibold mb-4">Termin stornieren</h2>

    <!-- Warning Alert -->
    <div class="p-3 mb-4 rounded bg-red-100 text-red-700 border border-red-300 flex items-start gap-2">
        <i class="pi pi-times-circle mt-1"></i>
        <span>Durch das Stornieren dieses Tickets werden alle aktiven Termine storniert.</span>
    </div>

    <!-- Reason Dropdown -->
    <div class="mb-3 flex flex-column gap-1">
        <label class="">Stornierungsgrund</label>
        <p-select
                [options]="reasons"
                [(ngModel)]="selectedReason"
                placeholder="Bitte wählen Sie einen Grund"
                optionLabel="name"
                class="w-full"
                styleClass="w-full"
                panelStyleClass="w-full"
                appendTo="body"
        ></p-select>
    </div>

    <!-- Comment Textarea -->
    <div class="mb-3 flex flex-column gap-1">
        <label class="">Kommentar</label>
        <textarea
                [(ngModel)]="comment"
                rows="4"
                placeholder="Geben Sie einen Kommentar ein..."
                class="w-full p-inputtext"
        ></textarea>
    </div>

    <!-- Info Box -->
    <div class="p-4 mb-4 border border-blue-200 bg-blue-50 rounded text-sm text-gray-800">
        <div class="flex align-items-center gap-2 mb-2">
            <i class="pi pi-info-circle text-primary-500"></i>
            <span class="font-medium text-xl">Folgen</span>
        </div>
        <ul class="list-disc list-inside ml-6">
            <li>Alle aktiven Termine werden storniert und abgeschlossen.</li>
            <li>Die Zeitfenster des Beraters werden sofort freigegeben.</li>
            <li>Kunde und Berater werden automatisch benachrichtigt.</li>
            <li>Diese Aktion wird im Audit-Log protokolliert.</li>
        </ul>
    </div>

    <!-- Submit Button -->
    <div class="text-right">
        <button
                pButton
                type="button"
                label="Termin stornieren"
                class="p-button-danger"
                [disabled]="!selectedReason"
                (click)="confirmCancelAppointment()"
        ></button>
    </div>
</div>